var alignment_rtlignore_default = {
  "alignLeft": "BNoaq",
  "textWrapNowrap": "hg7k3",
  "alignRight": "Tabv9",
  "alignCenter": "b-USz",
  "sizeFullWidth": "_0NAZs",
  "renderedInTable": "_4iRD-",
  "sizeOriginal": "DlJg0",
  "sizeContent": "YhiBG",
  "sizeSmall": "Hejk8",
  "sizeSmallCenter": "SkUYy",
  "flex": "Y7MiA",
  "LEFT": "Fhx6C",
  "CENTER": "FEAwC",
  "RIGHT": "_2pg2h",
  "AUTO": "T-WDm",
  "JUSTIFY": "EablJ"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
